import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'components/Select';
import { t } from 'utils/getLiteral';
import Literal from 'components/literal';
import { ServerListActions } from 'actions';

function mapStateToProps({ serverList }, { list }) {
    const listData = serverList[list] || {};
    return {
        loading: listData.loading || false,
        listOptions: listData.data || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getList: bindActionCreators(ServerListActions, dispatch).getList,
    };
}

class CrudSelect extends PureComponent {
    componentDidMount() {
        const { getList, list } = this.props;
        if (list && list.length > 0) {
            getList(list);
        }
    }

    componentDidUpdate(prevProps) {
        const { list, getList } = this.props;
        if (list && list.length > 0 && list !== prevProps.list) {
            getList(list);
        }
    }

    onChange = (value) => {
        const { input, onChange = () => null, emptyValue = '' } = this.props;
        const finalVal = value ? value.value : emptyValue;
        input.onChange(finalVal);
        onChange(finalVal);
    };

    render() {
        const {
            list,
            input,
            options,
            listOptions = [],
            readOnly,
            placeholder = 'label_selectone',
            isClearable = true,
            isSearchable = true,
            dataTest,
            autoFocus,
            linkAction,
            meta: { touched, error },
        } = this.props;
        const { value, onBlur } = input;
        // if we have a list, we use a server list (prop listOptions), otherwise we use prop options
        const finalOptions = list ? listOptions : options;

        let cleanValue = value ? value.toString().toLowerCase() : null;

        cleanValue =
            typeof cleanValue === 'string' && cleanValue.length
                ? finalOptions.find(
                      (option) => option.value.toString().toLowerCase() === cleanValue,
                  )
                : cleanValue;

        if (!cleanValue && value?.value) cleanValue = value;

        const hasError = touched && error;

        const classNames = ['custom-react-select'];
        if (linkAction) {
            classNames.push('has-link-action');
        }

        return (
            <Fragment>
                <Select
                    isSearchable={isSearchable}
                    className={classNames.join(' ')}
                    classNamePrefix="custom-react-select"
                    value={cleanValue}
                    options={finalOptions}
                    onBlur={(val) => onBlur(val.value)}
                    onChange={this.onChange}
                    isDisabled={readOnly}
                    placeholder={t(placeholder)}
                    isClearable={isClearable}
                    hasError={hasError}
                    dataTest={dataTest}
                    autoFocus={autoFocus}
                />
                {hasError && (
                    <p className="crud-error-message">
                        <Literal literal="cfm_label_required_field" />
                    </p>
                )}
                {linkAction && (
                    <div className="crud-link-action">
                        <div
                            role="button"
                            tabIndex="-1"
                            className="crud-link-action__btn"
                            onClick={linkAction.onClick}
                        >
                            {linkAction.text}
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

CrudSelect.propTypes = {
    input: PropTypes.shape({}).isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ).isRequired,
    listOptions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ),
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    placeholder: PropTypes.string,
    isSearchable: PropTypes.bool,
    isClearable: PropTypes.bool,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
    emptyValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
    list: PropTypes.string,
    getList: PropTypes.func.isRequired,
    dataTest: PropTypes.string.isRequired,
    linkAction: PropTypes.shape({
        text: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(CrudSelect);
